import React, {ReactNode} from 'react';
import classNames from 'classnames';
import {Nullable} from 'js/reusable/types/general';
import {setTestId} from 'js/reusable/testing/setTestId';

type IProps = {
	after?: ReactNode;
	onChange:  (value: any) => void;
	isChecked?: boolean,
	checkboxClassName?: string,
	text?: ReactNode,
	className?:string,
	name?:string,
	writeToDom?: boolean,
	disabled?: boolean,
	htmlFor?: string,
	neutral?: boolean,
	value?: any,
	testId?: Nullable<string>,
}

function LazyCheckbox({
	after,
	onChange,
	isChecked,
	checkboxClassName,
	text,
	className =  '',
	name =       '',
	writeToDom = false,
	disabled =   false,
	htmlFor =        '',
	neutral =    false,
	value =      null,
}: IProps) {
	const classes = classNames(
		'httpool-checkbox-button tw-px-1.5 tw-inline tw-overflow-hidden tw-bg-center tw-bg-no-repeat',
		{
			'httpool-checkbox-disabled':
				disabled && !isChecked,
		},
		{
			'httpool-checkbox-neutral':
				neutral && !isChecked,
		},
		{
			'httpool-checkbox-checked-disabled':
				disabled && isChecked,
		},
		{'httpool-checkbox-checked': isChecked},
		checkboxClassName
	);

	function handleChange(e: React.MouseEvent<Element, MouseEvent>) {
		e.stopPropagation();

		if (!disabled) {
			onChange(e);
		}
	}

	// save value to dom for legacy form handlers
	function inputVal() {
		if (!writeToDom) {
			return '';
		}

		return (
			<input
				type="hidden"
				id={name}
				name={name}
				value={isChecked ? value || '1' : '0'}
			/>
		);
	}

	function renderAfterComponent() {
		if (after) {
			return after;
		}
	}

	return (
		<label
			htmlFor={htmlFor}
			onClick={handleChange}
			style={!disabled ? {cursor: 'pointer'} : {}}
			className={className}
		>
			<div
				id={'test-' + htmlFor}
				data-testid={setTestId('testId')}
				className={classes}
			/>

			{text}

			{inputVal()}
			{renderAfterComponent()}
		</label>
	);
}

export default LazyCheckbox;
